import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import type { DateField as TDateField } from "src/components/Form/Form.types.ts";
import { DatePickerV2 } from "src/components/DatePickerV2/DatePickerV2.tsx";
import dayjs from "dayjs";

export const DatePickerField = ({
  name,
  field,
  disabled,
  floatingError,
}: {
  name: string;
  field: TDateField;
  isLoading?: boolean;
  floatingError?: boolean;
  disabled?: boolean;
}) => {
  const form = useFormContext();

  return (
    <Controller
      key={name}
      control={form.control}
      render={({ field: { value, onChange }, formState: { errors } }) => (
        <DatePickerV2
          mode={field.mode || "date"}
          disabled={disabled}
          value={value ? dayjs(value) : null}
          floatingError={floatingError}
          onChange={(value) =>
            onChange(value ? value.format("YYYY-MM-DD HH:mm:ss") : null)
          }
          label={field.label}
          error={errors?.root?.[name]?.message}
        />
      )}
      name={name}
    />
  );
};
